import axios from "axios";

import { loadToken } from "./utils/TokenUtils";
import SignOutService from "services/SignOutService";

import routes from "constants/ApiRoutesConstants";

const UNAUTHENTICATED = "unAuthenticated";

const instance = axios.create({
  // baseURL: "http://icsg48w.146.190.160.158.sslip.io/api/v1",
  baseURL: "https://backend-platform-stock-rule-book.fly.dev/api/v1",
});

instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent

    const token = loadToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },

  function (error) {
    // Do something with request error

    if (!error) {
      return Promise.reject(error);
    }

    const userTypes = localStorage.getItem("userType");

    if (userTypes !== UNAUTHENTICATED && error.response.status === 401) {
      // SignOutService();
    }

    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error

    console.log(error, "helo");

    console.log(error.response, "heloooooooooo ");

    if (error.response && error.response.status === 0) {
      SignOutService();
    }

    if (
      error.response &&
      error.response.status === 401
      // !error.config.url.includes(routes.LOGIN)
    ) {
      console.log("helo helo helo");
      SignOutService(); // Call SignOutService for 401 errors except on SignIn API
    }

    return Promise.reject(error);
  }
);

export default instance;
